import { ref } from 'vue'

const serverConnection = ref(false)

export function useGlobalState() {
    return {
        serverConnection
    }
}